import { CrmUserPostRequestDto } from './crm-user-post.request.dto';

export type CrmUserPatchRequestDto = Partial<Omit<CrmUserPostRequestDto, 'login'>>;
